module.exports = __webpack_public_path__ + "img/peru.d4daa0f5.png";